import { createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import fetch from "cross-fetch";
import { BASE_URL } from "../config/api_collection";
import getEvnData from "../env";
import { getToken, getSessionToken } from "../helper/token";

const { graphqlServer } = getEvnData(process.env.REACT_APP_ENV || "local");
const ORDER_ID_API = `${BASE_URL}/orderID`;
const CANCEL_BOOKING_API = `${BASE_URL}/cancelBooking`;


const API_URL = graphqlServer;
const ORDER_API = ORDER_ID_API;

export const httpLink = createHttpLink({
  uri: API_URL,
  fetch
});

// for order id
export const httpLinkForOrderApi = createHttpLink({
  uri: ORDER_API,
  fetch
});

// for cancel booking
export const httpLinkForCancelBookingApi = createHttpLink({
  uri: CANCEL_BOOKING_API,
  fetch
});

export const authLink = setContext(async (_, { headers }) => {
  const tokenHeaders = await getToken();
  const xsessionToken = await getSessionToken();

  tokenHeaders["Content-Type"] = "application/json";
  tokenHeaders.Accept = "application/json";
  if (xsessionToken) {
    tokenHeaders["x-session-token"] = xsessionToken;
  }

  return {
    headers: tokenHeaders
  };
});
